export default function TermsPage({ t }) {
  const tp = t.termsPage;

  return (
    <section
      id="terms-page"
      data-testid="terms-page"
      className="bg-white border-b border-[#e2e6ec]"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
        <a
          data-testid="terms-back-home"
          href="/"
          className="inline-flex font-mono text-[10px] uppercase tracking-[0.25em] text-[#0b378c] hover:text-[#082a6e] transition-colors mb-8"
        >
          ← {tp.backHome}
        </a>

        <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#e3191b] mb-3">
          {tp.eyebrow}
        </div>
        <h1 className="font-[Barlow_Condensed] font-bold uppercase tracking-tight text-[#0b1220] text-4xl sm:text-5xl leading-[0.95]">
          {tp.title}
        </h1>
        <p className="mt-5 text-lg text-[#0b378c] font-medium leading-snug border-l-4 border-[#e3191b] pl-4">
          {tp.subtitle}
        </p>
        <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
          {tp.updatedLabel}{" "}
          <span className="text-slate-700">{tp.updatedValue}</span>
        </p>
        <p className="mt-6 text-sm text-slate-600 leading-relaxed bg-[#f7f8fa] border border-[#e2e6ec] px-4 py-3">
          {tp.disclaimer}
        </p>

        <div className="mt-12 space-y-12">
          {tp.sections.map((sec, i) => (
            <article key={i} className="scroll-mt-24">
              <h2 className="font-[Barlow_Condensed] font-bold text-xl sm:text-2xl text-[#0b1220] uppercase tracking-tight">
                {sec.title}
              </h2>
              {sec.paragraphs?.map((p, j) => (
                <p key={j} className="mt-4 text-sm sm:text-[15px] text-slate-600 leading-relaxed">
                  {p}
                </p>
              ))}
              {sec.listLead ? (
                <p className="mt-4 text-sm text-slate-600 leading-relaxed">{sec.listLead}</p>
              ) : null}
              {sec.bullets?.length ? (
                <ul className="mt-4 list-disc pl-5 space-y-2 text-sm sm:text-[15px] text-slate-600 leading-relaxed marker:text-[#0b378c]">
                  {sec.bullets.map((b, k) => (
                    <li key={k}>{b}</li>
                  ))}
                </ul>
              ) : null}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
